import './VtxTag.scss';
import * as React from 'react';
import { Tag } from 'antd';
import { TagProps } from 'antd/lib/tag';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
import { assertNever } from '../../helpers/neverCheckers';

export type TagColors =
    | 'default'
    | 'green'
    | 'blue'
    | 'cobalt'
    | 'cyan'
    | 'red'
    | 'purple'
    | 'orange'
    | 'gold'
    | 'tangerine'
    | 'magenta';

export interface VtxTagProps extends Omit<TagProps, 'color'>, IAutomatable {
    /**
     * To specify the color of the tag
     * @default 'default'
     */
    color?: TagColors;
    /**
     * To specify the direction of where icon is displayed
     * @default 'left'
     */
    iconDirection?: 'right' | 'left';
}

function determineColorCssClass(color: TagColors): string {
    if (color === 'default') {
        return 'vtx-tag-default';
    } else if (color === 'blue') {
        return 'vtx-tag-blue';
    } else if (color === 'cobalt') {
        return 'vtx-tag-cobalt';
    } else if (color === 'cyan') {
        return 'vtx-tag-cyan';
    } else if (color === 'gold') {
        return 'vtx-tag-gold';
    } else if (color === 'green') {
        return 'vtx-tag-green';
    } else if (color === 'magenta') {
        return 'vtx-tag-magenta';
    } else if (color === 'orange') {
        return 'vtx-tag-orange';
    } else if (color === 'purple') {
        return 'vtx-tag-purple';
    } else if (color === 'red') {
        return 'vtx-tag-red';
    } else if (color === 'tangerine') {
        return 'vtx-tag-tangerine';
    } else {
        return assertNever(color);
    }
}

export const VtxTag: FunctionComponent<VtxTagProps> = React.memo((props: VtxTagProps) => {
    const automationClass = 'vtx-tag';
    const { className, iconDirection, ...otherProps } = preventDataAutomationOverriding(props);
    let color = props.color;
    if (color === undefined) {
        color = 'default';
    }
    const colorClassName = determineColorCssClass(color);
    const listOfClassNames = [automationClass, colorClassName, className];
    const classNamesCombined =
        iconDirection === 'right'
            ? classNames(listOfClassNames, 'vtx-right-direction-icon')
            : classNames(listOfClassNames);

    return (
        <Tag className={classNamesCombined} data-automation-class={automationClass} {...otherProps}>
            {props.children}
        </Tag>
    );
});
